import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const allowedPaths = [
  "/home",
  "/incident",
  "/incident-add",
  "/incident-edit",
  "/usermanagement",
  "/problem",
  "/problem-add",
  "/problem-edit",
  "/task",
  "/task-add",
  "/task-edit",
  "/change",
  "/change-add",
  "/change-edit",
  "/rma-request",
  "/rma-add",
  "/rma-edit",
  "/knowledge-base",
  "/knowledgeBase-add",
  "/knowledgeBase-edit",
  "/calendar",
  "/schedule",
  "/delegation",
  "/superadmin",
  "/update",
  "/roles",
  "/responsiblepersons",
  "/sla",
  "/admin",
  "/adminRequest-add",
  "/adminRequest-edit",
  "/reports",
  "/reporting",
];

const ProtectedRoute = ({ element }: { element: React.ReactElement }) => {
  const token = localStorage.getItem("authToken");
  const location = useLocation();
  const [redirectToHome, setRedirectToHome] = useState(false);

  useEffect(() => {
    if (!token) return;

    try {
      const navEntry = performance.getEntriesByType("navigation")[0];
      const isHardLoad =
        (navEntry as PerformanceNavigationTiming)?.type === "navigate" ||
        (navEntry as PerformanceNavigationTiming)?.type === "reload";

      if (isHardLoad) {
        // Check if current path starts with any allowed path
        const allowed = allowedPaths.some(
          (path) =>
            location.pathname === path ||
            location.pathname.startsWith(path + "/"),
        );

        if (!allowed) {
          setRedirectToHome(true);
        }
      }
    } catch {
      // If unsupported, do nothing
    }
  }, [location.pathname, token]);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (redirectToHome) {
    return <Navigate to="/home" replace />;
  }

  return element;
};

export default ProtectedRoute;
